// extracted by mini-css-extract-plugin
export default {"courseCard":"CreateNewCourseItem_courseCard__hXZoA","courseLink":"CreateNewCourseItem_courseLink__BAGtp","createBtn":"CreateNewCourseItem_createBtn__nw5EW"};